import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TextAnimate = ({ text }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const chars = containerRef.current.querySelectorAll('.char');

    gsap.set(chars, { opacity: 0, x: 0 });

    gsap.to(chars, {
      scrollTrigger: {
        trigger: containerRef.current,
        start: 'top 85%',
      },
      opacity: 1,
      y: 0,
      stagger: 0.05,
      duration: 1,
      ease: 'power3.out',
    });

    return () => {
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return (
    <span className="text-anime-style-3" ref={containerRef}>
      {text.split(' ').map((word, wordIndex) => (
        <span className="word-wrapper" key={wordIndex}>
          {word.split('').map((char, charIndex) => (
            <span key={charIndex} className="char">
              {char}
            </span>
          ))}
          &nbsp;
        </span>
      ))}
    </span>
  );
};

export default TextAnimate;